import moment from 'moment';
import { compact } from 'lodash';

import { DATE_FORMATS } from 'constants/dateFormats';

import evolve from './evolve';
import { formatDate } from './commonMapper';

const ApprovalMapper = {
    lastWorkplace: (field) => {
        let {organizationName, position, beginWorking, endWorking} = field;
        let lastEmployed = organizationName, untilNow = '';

        lastEmployed += position ? ` (${position})` : '';
        if (beginWorking) {
            lastEmployed += `, ${moment(beginWorking, DATE_FORMATS.parse).format(DATE_FORMATS.monthYearFormat)} - `;
            if (endWorking) {
                lastEmployed += moment(endWorking, DATE_FORMATS.parse).format(DATE_FORMATS.monthYearFormat);
            } else {
                untilNow = 'person.untilNow';
            }
        }
        return { lastEmployed, untilNow };
    },
    letter: (field) => {
        return compact(field.split(/<br>|<br \/>|<br\/>/gm).filter((item) => item.indexOf('пройдите по ссылке') === -1 ))
                    .join('<br>').replace('><br><', '><');
    }
};

export const personApprovalMapper = evolve({
    lastWorkplace: ApprovalMapper.lastWorkplace,
    letter: ApprovalMapper.letter,
    date: formatDate,
    birthdate: formatDate
});

export const projectApprovalMapper = evolve({
    documents: { date: formatDate },
    letter: ApprovalMapper.letter,
    closebefore: formatDate,
    inworkdate: formatDate,
    deadline: formatDate,
    date: formatDate
});

export const applicationApprovalCountersMapper = counters => ({
    inwork: counters.inwork,
    cancel: counters.cancelled,
    close: counters.closed,
});
